import { Theme } from '@carbon/react';
import { setBrandingSource } from '@pos/design-system';
import { detectLanguage, initI18n } from '@pos/i18n';
import { registerAppServiceWorker } from '@pos/offline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Root } from './Root';
import { UpdateNotice } from './UpdateNotice';
import { hoApi } from './api';
import './styles.scss';

initI18n(detectLanguage());
registerAppServiceWorker({ base: import.meta.env.BASE_URL, enabled: import.meta.env.PROD });
// The platform note head office set, over branding.json (ADR 0106).
setBrandingSource(async () => (await hoApi.GET('/api/v1/identity/branding')).data);

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 10_000 } } });

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('index.html must contain #root');

createRoot(rootElement).render(
  <StrictMode>
    <Theme theme="white">
      <UpdateNotice />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Root />
        </BrowserRouter>
      </QueryClientProvider>
    </Theme>
  </StrictMode>,
);
